var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 4,
    fill: "#00529C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7513 21.6914H24.0876C25.4386 21.6914 26.4458 22.2892 26.4458 23.5476C26.4458 24.4702 25.9789 24.9841 25.1678 25.2563V25.277C26.1345 25.4768 26.6334 26.0012 26.6334 26.8919C26.6334 28.6434 25.1052 29.0101 23.8064 29.0101H20.7513V21.6914ZM22.6837 24.5854H23.2246C23.8586 24.5854 24.5137 24.4281 24.5137 23.809C24.5137 23.1387 23.8899 23.0752 23.2449 23.0752H22.6837V24.5854ZM22.6837 27.6263H23.2563C23.9623 27.6263 24.7 27.5213 24.7 26.7767C24.7 25.9804 23.9418 25.9064 23.2765 25.9064H22.6837V27.6263Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1704 21.6914H31.54L34.3357 29.0101H32.2153L31.6754 27.4482H28.9524L28.3805 29.0101H26.4164L29.1704 21.6914ZM30.3557 23.2016H30.3338L29.3991 26.0644H31.2176L30.3557 23.2016Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6047 21.6914H37.0677L39.5205 26.6618H39.5407L39.51 21.6914H41.2773V29.0101H38.8764L36.3398 24.0087H36.3199L36.3819 29.0101H34.6047V21.6914Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9334 21.6914H43.8662V24.6806H43.887L46.0687 21.6914H48.3975L45.7157 25.099L48.6054 29.0101H46.1415L43.887 25.6865H43.8662V29.0101H41.9334V21.6914Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0018 21.6914H54.3381C55.6888 21.6914 56.6973 22.2892 56.6973 23.5476C56.6973 24.4702 56.2304 24.9841 55.4193 25.2563V25.277C56.3857 25.4768 56.8846 26.0012 56.8846 26.8919C56.8846 28.6434 55.3567 29.0101 54.0582 29.0101H51.0018V21.6914ZM52.9352 24.5854H53.4752C54.1094 24.5854 54.7636 24.4281 54.7636 23.809C54.7636 23.1387 54.1407 23.0752 53.4967 23.0752H52.9352V24.5854ZM52.9352 27.6263H53.5071C54.2132 27.6263 54.9515 27.5213 54.9515 26.7767C54.9515 25.9804 54.1929 25.9064 53.5277 25.9064H52.9352V27.6263Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3129 21.6914H60.7634C62.0518 21.6914 63.102 22.2783 63.102 23.5374C63.102 24.5124 62.6446 25.1625 61.7095 25.3824V25.4031C62.3318 25.5713 62.3742 26.1266 62.7379 27.018L63.4449 29.0101H61.429L61.013 27.6898C60.6179 26.4314 60.3683 26.1161 59.6512 26.1161H59.2457V29.0101H57.3129V21.6914ZM59.2457 24.7323H59.7553C60.3788 24.7323 61.1689 24.7109 61.1689 23.8827C61.1689 23.2016 60.4926 23.0752 59.7553 23.0752H59.2457V24.7323Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13940_6826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 18,
    width: 62,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 32.7057H65.9102V18H4V32.7057Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13940_6826)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9774 29.0101H65.9102V21.6914H63.9774V29.0101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3402 18H6.2234C4.99542 18 3.99994 19.0293 3.99994 20.2991V20.3234V30.4072C3.99994 31.6647 4.97707 32.6869 6.18923 32.7057H16.3348C17.5631 32.7057 18.5589 31.6765 18.5589 30.4072L18.5636 20.2991C18.5636 19.0293 17.5684 18 16.3402 18ZM7.42607 31.5274L6.87408 31.5335C6.206 31.5335 5.66445 30.9798 5.66445 30.2965L5.66129 30.1991V20.864L5.66477 20.3614C5.68976 19.7001 6.18765 19.1678 6.83992 19.1678H7.96193C8.9786 19.1678 9.80327 20.0598 9.80327 21.1123C9.80327 21.6326 9.60113 22.1049 9.27374 22.4483L6.41098 25.379L9.09406 28.1355C9.44012 28.4952 9.64921 28.9682 9.64921 29.4862C9.64921 30.6137 8.65374 31.5274 7.42607 31.5274ZM15.6746 31.5182L10.6722 31.516C10.6722 31.516 11.2508 30.2547 11.2508 29.474C11.2508 28.5223 10.9351 27.6718 10.4413 27.1091L8.73029 25.3494L10.4767 23.5289C10.9964 23.0359 11.3419 22.1607 11.3419 21.164C11.3419 20.3748 11.1255 19.6755 10.7772 19.1678H11.9894C13.0064 19.1678 13.8311 20.0598 13.8311 21.1123C13.8311 21.6326 13.6292 22.1049 13.3018 22.4483L10.4938 25.3484L16.3259 31.3487C16.1412 31.4662 15.9081 31.5182 15.6746 31.5182ZM16.8963 29.6448L12.7166 25.3471L14.7073 23.3059C15.1128 22.7949 15.3697 22.0248 15.3697 21.164C15.3697 20.3697 15.1501 19.6535 14.7987 19.1454L15.6898 19.1722C16.3579 19.1722 16.8994 19.7269 16.8994 20.4099L16.8963 29.6448Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBri);
export default __webpack_public_path__ + "static/media/BRI.9998fc499ab0664b77ec8b9faeae374a.svg";
export { ForwardRef as ReactComponent };